import React, { Component } from "react";
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect, isLoaded, isEmpty  } from 'react-redux-firebase'
import GoogleButton from 'react-google-button'

import AdminDashboard from "./AdminDashboard";
import './Admin.css';

class Admin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      authenticated: false,
      authorized: false
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps === this.props) {
      return
    }
    this.setState({
      authenticated: !isEmpty(nextProps.auth),
      authorized: !isEmpty(nextProps.profile)
    })
  }

  onClickGoogleSignIn = () => {
    this.props.firebase.login({ provider: 'google', type: 'popup'})
    .then(auth => {
      this.setState({
        authenticated: !isEmpty(this.props.auth),
        authorized: !isEmpty(this.props.profile)
      })
    })
    .catch(e => {
      console.log(e)
      this.setState({
        authorized: false,
        authenticated: true
      })
    })
  }

  render() {
    return (
      <div>
        {
          !this.state.authorized &&
          <div className="signin-box">
            <GoogleButton onClick={this.onClickGoogleSignIn} />
            {
              isLoaded(this.props.auth) &&
              isLoaded(this.props.profile) &&
              this.state.authenticated &&
              <div className="sigin-error">
                <p>{this.props.auth.email || "This account"} is not allowed to login admin page.</p>
                <p>Sign in with another gmail account.</p>
              </div>
            }
          </div>
        }
        {
          this.state.authorized &&
          <AdminDashboard />
        }
      </div>
    )
  }
}

export default compose(
  firebaseConnect(),
  connect(({ firebase: {auth, profile} }) => ({ auth, profile }))
)(Admin)


// WEBPACK FOOTER //
// ./src/Admin.js